import React, { useState, useEffect } from 'react';
import NavBarHome from './NavBarHome';
import FooterHome from './FooterHome';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLock,
  faFileContract,
  faCookieBite,
  faWandSparkles,
  faSpaghettiMonsterFlying, // Replace if not available
} from '@fortawesome/free-solid-svg-icons';

const styles = {
  container: {
    fontFamily: "'Helvetica Neue', Arial, sans-serif",
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  // Tabs Header placed immediately after the navbar
  tabsHeader: {
    backgroundImage: 'url("https://via.placeholder.com/1200x100")', // Replace with your image URL
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '100px', // Smaller header height so only horizontal centering is applied
    display: 'flex',
    alignItems: 'flex-start', // Align items to the top
    justifyContent: 'center', // Center horizontally
    paddingTop: '20px',
  },
  mainSection: {
    padding: '50px 20px',
    textAlign: 'center',
    backgroundColor: '#f9f9f9',
    flex: '1',
  },
  title: {
    fontSize: '48px',
    color: '#333',
    marginBottom: '20px',
    fontWeight: 'bold',
  },
  headerSubtitle: {
    fontSize: '20px',
    color: '#555',
    marginBottom: '40px',
    fontWeight: 'normal',
  },
  legalText: {
    fontSize: '16px',
    color: '#666',
    lineHeight: '1.6',
    maxWidth: '800px',
    margin: '10px auto',
    textAlign: 'justify',
    whiteSpace: 'pre-wrap',
    fontWeight: 'normal',
  },
  // Centered subsection titles with only the first letter capitalized
  subsectionTitle: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#333',
    margin: '20px 0 10px 0',
    textAlign: 'center',
  },
  // Update date style
  updateDate: {
    fontSize: '14px',
    textAlign: 'center',
    marginTop: '30px',
    fontWeight: 'normal',
  },
  readMoreLink: {
    display: 'inline-block',
    marginTop: '20px',
    fontSize: '16px',
    color: '#ff2300',
    textDecoration: 'none',
    fontWeight: 'bold',
  },
};

const translations = {
  es: {
    privacy: {
      headerTitle: 'Política de privacidad',
      headerSubtitle: '',
      content: (
        <>
          <h2 style={styles.subsectionTitle}>1. Introducción</h2>
          <p style={styles.legalText}>
            En Bether trabajamos para ofrecer la mejor experiencia posible a
            nuestros usuarios mediante nuestros productos y servicios. Para
            lograrlo, recopilamos información personal cuando es necesario.
            <br />
            En cumplimiento con el REGLAMENTO (UE) 2016/679 DEL PARLAMENTO
            EUROPEO Y DEL CONSEJO del 27 de abril de 2016 ("RGPD"), y la Ley
            34/2002, de 11 de julio, de Servicios de la Sociedad de la
            Información y de Comercio Electrónico ("LSSI"), Bether informa que
            tratará los datos personales facilitados por los usuarios de manera
            responsable y segura.
          </p>

          <h2 style={styles.subsectionTitle}>2. Responsable del tratamiento</h2>
          <p style={styles.legalText}>
            Bether Talent, SL (en adelante, “Bether” o la “Empresa”) es la
            responsable del tratamiento de los datos personales de los usuarios.
            Sus datos generales son:
            <br />
            <strong>Identidad:</strong> Bether Talent,SL
            <br />
            <strong>Dirección:</strong> Marques de Sentmenat 26 08014 Barcelona
            <br />
            <strong>NIF:</strong> B21864202
            <br />
            <strong>Correo electrónico:</strong> legal@bether.ai
          </p>
          <p style={styles.legalText}>
            Bether cuenta con un Delegado de Protección de Datos. Si tienes
            dudas sobre el tratamiento de tus datos, puedes escribirnos a la
            dirección de correo electrónico indicada.
          </p>

          <h2 style={styles.subsectionTitle}>
            3. Recogida y tratamiento de datos personales
          </h2>
          <p style={styles.legalText}>
            Podemos recopilar y tratar los siguientes datos personales:
            <br />
            <strong>Formulario de contacto:</strong> Nombre, apellidos, correo
            electrónico, teléfono y mensaje opcional.
            <br />
            <strong>Registro en la plataforma:</strong> Nombre, apellidos,
            correo electrónico, teléfono y contraseña. Se podrá registrar
            mediante terceros como Google o Facebook.
            <br />
            <strong>Comunicaciones comerciales:</strong> Correo electrónico y
            otros datos necesarios para gestionar el servicio.
            <br />
            <strong>Atención al cliente:</strong> Correo electrónico y cualquier
            información compartida en el chat de soporte.
            <br />
            <strong>Formulario de empleo:</strong> Nombre, apellidos, correo
            electrónico, teléfono, CV y, opcionalmente, fotografía. Se puede
            postular mediante LinkedIn o Indeed.
          </p>

          <h2 style={styles.subsectionTitle}>4. Base legal del tratamiento</h2>
          <p style={styles.legalText}>
            El tratamiento de los datos se justifica en:
            <br />- <strong>Consentimiento del usuario:</strong> Para
            formularios de contacto, suscripción a newsletters, candidaturas
            laborales y atención al cliente.
            <br />- <strong>Cumplimiento de obligaciones legales:</strong> Para
            prevención de fraude y comunicación con autoridades públicas.
            <br />- <strong>Ejecución de un contrato:</strong> Cuando el
            tratamiento sea necesario para la prestación de nuestros servicios.
          </p>

          <h2 style={styles.subsectionTitle}>5. Conservación de los datos</h2>
          <p style={styles.legalText}>
            Los datos personales se conservarán únicamente durante el tiempo
            necesario para cumplir los fines para los cuales fueron recopilados
            o para cumplir con obligaciones legales. Esto significa que el
            período de conservación puede variar en función de la naturaleza de
            los datos y el motivo de su tratamiento.
            <br />
            Para determinar cuánto tiempo conservamos los datos personales,
            utilizamos los siguientes criterios:
            <br />-{' '}
            <strong>
              Datos personales proporcionados en consultas o solicitudes:
            </strong>{' '}
            Se conservarán mientras sean necesarios para responder y gestionar
            la consulta.
            <br />-{' '}
            <strong>
              Datos personales recopilados con consentimiento para
              comunicaciones comerciales:
            </strong>{' '}
            Se conservarán hasta que el usuario retire su consentimiento o hasta
            el final del período por el cual fueron requeridos.
            <br />-{' '}
            <strong>
              Datos personales tratados para la ejecución de un contrato:
            </strong>{' '}
            Se conservarán durante la relación contractual y posteriormente por
            el tiempo necesario para cumplir con obligaciones legales.
            <br />-{' '}
            <strong>
              Datos personales relacionados con obligaciones legales o
              regulatorias:
            </strong>{' '}
            Se conservarán por el período exigido por la legislación aplicable.
            <br />
            En algunos casos, podemos conservar datos personales por períodos
            más largos si es necesario para cumplir con obligaciones legales,
            resolver disputas o hacer valer nuestros derechos legales (por
            ejemplo, para presentar demandas en tribunales).
            <br />
            Una vez transcurridos los períodos de conservación establecidos,
            procederemos a la eliminación de los datos personales de nuestros
            sistemas y registros de manera segura o, en su caso, los
            anonimizaremos para que ya no sea posible identificar al usuario.
            <br />
            Bether dispone de una Política de Retención de Datos que especifica
            los períodos de conservación en detalle. Para obtener más
            información, puedes contactar a legal@bether.ai.
          </p>

          <h2 style={styles.subsectionTitle}>6. Compartición de datos</h2>
          <p style={styles.legalText}>
            En algunos casos, y solo cuando sea necesario, Bether podrá
            compartir sus datos con terceros. No obstante, en ningún caso estos
            datos serán vendidos a terceros.
            <br />
            Los proveedores de servicios externos en los que Bether confía para
            la prestación de servicios auxiliares relacionados con el
            tratamiento de sus datos podrán tener acceso a ellos, siempre bajo
            las instrucciones de Bether y con el único propósito de cumplir
            adecuadamente con la relación contractual establecida entre Bether y
            dichos proveedores.
            <br />
            Si desea obtener información sobre los proveedores que pueden
            acceder a sus datos personales, puede contactarnos a través del
            correo electrónico: legal@bether.ai.
            <br />
            Bether se compromete a garantizar la seguridad de los datos
            personales cuando estos sean compartidos fuera de la empresa y a
            asegurar que los proveedores externos respeten la confidencialidad y
            adopten medidas adecuadas para su protección.
            <br />
            Estos terceros están obligados a tratar la información de
            conformidad con las normativas de privacidad de datos vigentes. Para
            garantizar estas medidas de protección, Bether suscribe acuerdos de
            procesamiento de datos con dichos proveedores, en cumplimiento del
            artículo 28 del Reglamento General de Protección de Datos (GDPR).
            <br />
            En determinados casos, la legislación aplicable puede exigir la
            divulgación de datos personales a administraciones públicas u otras
            entidades. En tales situaciones, Bether solo facilitará la
            información estrictamente necesaria para el cumplimiento de dichas
            obligaciones legales.
          </p>

          <h2 style={styles.subsectionTitle}>
            7. Almacenamiento y transferencia de datos
          </h2>
          <p style={styles.legalText}>
            En general, los datos se almacenan dentro de la Unión Europea (UE).
            No obstante, en caso de que el tratamiento de sus datos implique una
            transferencia internacional fuera del Espacio Económico Europeo
            (EEE), Bether se compromete a implementar las medidas de seguridad
            necesarias para garantizar un nivel adecuado de protección en dichas
            transferencias.
            <br />
            Para ello, Bether suscribe contratos de procesamiento de datos con
            los proveedores involucrados y, cuando corresponda, se asegura de
            que ofrezcan un nivel de protección adecuado, ya sea mediante Normas
            Corporativas Vinculantes (BCR) o mediante la adhesión a las
            cláusulas tipo de la Comisión Europea.
            <br />
            Si desea obtener más información sobre nuestros proveedores de
            servicios, puede contactarnos a través del correo electrónico:
            legal@bether.ai.
          </p>

          <h2 style={styles.subsectionTitle}>8. Derechos del usuario</h2>
          <p style={styles.legalText}>
            El usuario puede ejercer los siguientes derechos:
            <br />- Acceder a sus datos personales.
            <br />- Rectificar información incorrecta o desactualizada.
            <br />- Solicitar la eliminación de sus datos.
            <br />- Restringir el tratamiento de su información.
            <br />- Recibir sus datos en un formato estructurado y legible.
            <br />- Oponerse a determinados tratamientos de sus datos.
            <br />
            Para ejercer estos derechos, envía una solicitud a legal@bether.ai.
            Si consideras que no hemos gestionado correctamente tus datos,
            puedes presentar una queja ante la Agencia Española de Protección de
            Datos (AEPD).
          </p>

          <h2 style={styles.subsectionTitle}>
            9. Responsable de la exactitud y veracidad de los datos facilitados
          </h2>
          <p style={styles.legalText}>
            El usuario es el único responsable de la veracidad y corrección de
            los datos facilitados, exonerando a Bether de cualquier
            responsabilidad al respecto. Los usuarios garantizan y responden en
            todo momento por la exactitud, vigencia y autenticidad de la
            información proporcionada, comprometiéndose a mantenerla
            actualizada.
            <br />
            El usuario se compromete a proporcionar información completa y veraz
            en los formularios de registro o suscripción. Bether se reserva el
            derecho de cancelar los servicios contratados en caso de detectar
            que los datos proporcionados son falsos, inexactos, incompletos o
            desactualizados.
            <br />
            Bether no se hace responsable de la veracidad de la información que
            provenga de fuentes externas y no elabora directamente, por lo que
            no asume responsabilidad por daños o perjuicios que puedan derivarse
            del uso de dicha información.
            <br />
            Bether se reserva el derecho de actualizar, modificar o eliminar
            información contenida en su sitio web, pudiendo incluso restringir o
            no permitir el acceso a la misma.
          </p>

          <h2 style={styles.subsectionTitle}>
            10. Medidas de seguridad para proteger tus datos personales
          </h2>
          <p style={styles.legalText}>
            Bether ha adoptado las medidas de seguridad necesarias para proteger
            los datos personales de acuerdo con la normativa vigente. Además,
            implementa otras medidas técnicas y organizativas para prevenir la
            pérdida, el uso indebido, la alteración, el acceso no autorizado o
            el robo de los datos personales proporcionados.
            <br />
            Bether no se hace responsable de los daños derivados de
            interferencias, omisiones, interrupciones, virus informáticos,
            fallos del sistema u otros inconvenientes fuera de su control.
            Asimismo, no puede garantizar la seguridad absoluta de la
            información en Internet, aunque aplica medidas avanzadas para
            protegerla.
            <br />
            El sitio web de Bether dispone de un certificado TLS con
            encriptación RSA, lo que garantiza que toda la información enviada a
            través del sitio está protegida mediante el protocolo HTTPS.
          </p>

          <h2 style={styles.subsectionTitle}>
            11. Cambios en la política de privacidad
          </h2>
          <p style={styles.legalText}>
            Esta política puede ser actualizada en cualquier momento. Te
            recomendamos que la revises periódicamente.
          </p>
          <p style={styles.updateDate}>Última actualización: 09/04/2025</p>
        </>
      ),
    },
    terms: {
      headerTitle: 'Términos y condiciones',
      headerSubtitle: 'Condiciones de uso',
      content: (
        <>
          <p style={styles.legalText}>
            Bether Talent, S.L. (En adelante Bether) es un servicio en línea que
            ayuda a gestionar diferentes aspectos de un negocio. Estos términos
            establecen los derechos y responsabilidades de los usuarios y de
            Bether como proveedor del servicio.
            <br />
            Al utilizar el servicio, los usuarios aceptan estos términos. Bether
            se reserva el derecho de actualizar o modificar las Condiciones de
            Uso en cualquier momento sin previo aviso. La versión más reciente
            estará siempre disponible en www.bether.ai.
            <br />
            Bether Talent, SL , con NIF B21864202, está ubicado en Marques de
            sentmenat 26, 08014 Barcelona, y registrado en el Registro Mercantil
            de Barcelona, Tomo XXX, Folio XX, Página XXXX, inscripción Xª.
            Bether ofrece su sitio web y los servicios relacionados de acuerdo
            con los términos establecidos a continuación.
            <br />
            Este acuerdo entra en vigor cuando lo aceptas marcando la casilla al
            final de este documento. Cualquier nueva función añadida al servicio
            también estará sujeta a estos términos. El uso continuo del servicio
            tras las modificaciones implica la aceptación de dichos cambios.
            Puedes consultar la versión más reciente en
            https://www.bether.ai/legal.
            <br />
            El incumplimiento de estos términos puede resultar en la cancelación
            de la cuenta.
          </p>

          <h2 style={styles.subsectionTitle}>1. Términos de la cuenta</h2>
          <p style={styles.legalText}>
            Debes tener al menos 16 años para utilizar el servicio.
            <br />
            Debes proporcionar un nombre completo, dirección de correo
            electrónico y cualquier otra información requerida al crear una
            cuenta.
            <br />
            Eres responsable de proporcionar información veraz. Bether se
            reserva el derecho de eliminar cuentas sospechosas de proporcionar
            información falsa o de violar las normas de uso.
            <br />
            Eres responsable de mantener la seguridad de tu cuenta. Bether no se
            hace responsable de ninguna pérdida o daño causado por la falta de
            protección de tus datos de acceso.
            <br />
            La aceptación electrónica de este acuerdo es legalmente vinculante.
            Bether puede solicitar una confirmación por escrito si es necesario.
          </p>

          <h2 style={styles.subsectionTitle}>2. Acuerdos</h2>
          <p style={styles.legalText}>
            Bether ofrece diferentes planes de precios basados en el volumen de
            documentos. Los límites se especifican en www.bether.ai/#pricing.
            <br />
            Si excedes los límites de tu plan, deberás actualizarlo.
            <br />
            Bether se reserva el derecho de cambiar los precios en cualquier
            momento sin compensación a los usuarios.
          </p>

          <h2 style={styles.subsectionTitle}>3. Pago y acceso</h2>
          <p style={styles.legalText}>
            Se requiere una tarjeta bancaria válida para realizar los pagos,
            excepto para las cuentas gratuitas.
            <br />
            Bether cobra las tarifas por adelantado, y los pagos no son
            reembolsables.
            <br />
            No se proporcionan reembolsos ni créditos por el tiempo no utilizado
            del servicio o meses parciales.
            <br />
            Los usuarios aceptan que la confirmación electrónica es suficiente
            para la aceptación del contrato.
            <br />
            Si se requiere una actualización de cuenta debido al volumen de
            documentos, el nuevo cargo se aplicará en el próximo ciclo de
            facturación.
            <br />
            En caso de impago, se revocará el acceso y los datos serán
            eliminados después de 30 días.
            <br />
            Las tarifas no incluyen impuestos; los usuarios son responsables de
            pagar los impuestos aplicables.
            <br />
            Los usuarios controlan quién puede acceder a sus cuentas y asignan
            roles en consecuencia.
          </p>

          <h2 style={styles.subsectionTitle}>
            4. Modificaciones del servicio y de los precios
          </h2>
          <p style={styles.legalText}>
            Bether puede modificar o suspender el servicio en cualquier momento,
            con o sin previo aviso.
            <br />
            Los cambios en los precios se anunciarán en el sitio web y por
            escrito con al menos 15 días de antelación.
          </p>

          <h2 style={styles.subsectionTitle}>5. Cancelación</h2>
          <p style={styles.legalText}>
            Los usuarios pueden cancelar su cuenta en cualquier momento a través
            del menú de perfil.
            <br />
            Una vez cancelada, todo el contenido será eliminado después de 30
            días.
            <br />
            Los usuarios son responsables de cualquier cargo incurrido hasta la
            cancelación, incluyendo las tarifas mensuales completas.
            <br />
            Bether se reserva el derecho de cancelar cuentas que violen estos
            términos.
          </p>

          <h2 style={styles.subsectionTitle}>
            6. Derechos de autor y propiedad intelectual
          </h2>
          <p style={styles.legalText}>
            Bether es propietario de todos los derechos de propiedad intelectual
            del servicio, incluyendo el software, el diseño y la imagen de
            marca.
            <br />
            Los usuarios no pueden copiar, adaptar, distribuir o realizar
            ingeniería inversa del servicio.
            <br />
            No se pueden utilizar herramientas automatizadas (por ejemplo, bots,
            arañas) para monitorear o copiar el contenido.
            <br />
            Los usuarios conservan la propiedad de su contenido, pero reconocen
            que terceros pueden visualizarlo o compartirlo a través del
            servicio.
          </p>

          <h2 style={styles.subsectionTitle}>7. Términos generales</h2>
          <p style={styles.legalText}>
            Los usuarios deben cumplir con las leyes aplicables y actuar de
            buena fe al utilizar Bether.
            <br />
            No se permite revender, duplicar o explotar ninguna parte del
            servicio sin el consentimiento por escrito de Bether.
            <br />
            El servicio no puede utilizarse para enviar spam ni para almacenar
            contenido dañino.
            <br />
            Bether no garantiza un servicio ininterrumpido o sin errores.
            <br />
            Bether no se hace responsable de ningún daño directo o indirecto que
            surja del uso del servicio.
            <br />
            Si alguna parte de estos términos se considera inválida, el resto de
            los términos seguirá aplicándose.
            <br />
            Las preguntas sobre estos términos deben dirigirse al Soporte
            Técnico de Bether: support@bether.ai.
            <br />
            Estos términos prevalecen sobre cualquier acuerdo previo y se rigen
            por la legislación española.
            <br />
            Cualquier disputa se resolverá en los tribunales de Barcelona.
          </p>

          <h2 style={styles.subsectionTitle}>8. Seguridad y privacidad</h2>
          <p style={styles.legalText}>
            Bether cumple con la normativa española de protección de datos y
            está registrado en la Agencia Española de Protección de Datos.
            <br />
            Los datos de los usuarios se almacenan en servidores de Amazon en la
            UE, garantizando el cumplimiento de la normativa de alojamiento de
            datos y altos estándares de seguridad.
          </p>

          <h2 style={styles.subsectionTitle}>Política de reembolso</h2>
          <p style={styles.legalText}>
            <strong>Suscripciones mensuales:</strong> Si no estás satisfecho
            durante tu primer mes, contáctanos. Intentaremos resolver el
            problema. Si sigues sin estar satisfecho, recibirás un reembolso
            completo y tu cuenta se degradará al plan gratuito.
            <br />
            <strong>Suscripciones anuales:</strong> Los planes anuales ofrecen
            un descuento. Si no estás satisfecho durante los primeros 30 días,
            contáctanos. Si no podemos resolver tu problema, te proporcionaremos
            un reembolso completo y tu cuenta se degradará al plan gratuito.
            <br />
            <strong>Renovación automática:</strong> Las suscripciones se
            renuevan automáticamente. Si olvidas cancelar antes de la
            renovación, aún puedes cancelarla dentro de los 7 días hábiles y
            recibir un reembolso completo.
            <br />
            <strong>Excepciones al reembolso:</strong> No se concederán
            reembolsos si tu cuenta fue suspendida o terminada debido a un
            incumplimiento de estos términos.
          </p>
        </>
      ),
    },
    cookies: {
      headerTitle: 'Política de cookies',
      headerSubtitle: 'Uso de cookies en nuestra plataforma.',
      content: (
        <>
          <h2 style={styles.subsectionTitle}>Política de cookies</h2>
          <p style={styles.legalText}>
            Esta política de cookies fue actualizada se aplica a los ciudadanos
            y residentes legales permanentes del Espacio Económico Europeo y
            Suiza.
          </p>
          <h2 style={styles.subsectionTitle}>Introducción</h2>
          <p style={styles.legalText}>
            Nuestra web, www.bether.ai (en adelante: «la web») utiliza cookies y
            otras tecnologías relacionadas (para mayor comodidad, todas las
            tecnologías se denominan «cookies»). Las cookies también son
            colocadas por terceros a los que hemos contratado. En el siguiente
            documento te informamos sobre el uso de cookies en nuestra web.
          </p>
          <h2 style={styles.subsectionTitle}>¿Qué son las cookies?</h2>
          <p style={styles.legalText}>
            Una cookie es un pequeño archivo que se envía junto con las páginas
            de esta web y que tu navegador almacena en el disco duro de su
            ordenador u otro dispositivo. La información almacenada puede ser
            devuelta a nuestros servidores o a los servidores de terceros
            apropiados durante una visita posterior.
          </p>
          <h2 style={styles.subsectionTitle}>¿Qué son los scripts?</h2>
          <p style={styles.legalText}>
            Un script es un fragmento de código de programa que se utiliza para
            hacer que nuestra web funcione correctamente y de forma interactiva.
            Este código se ejecuta en nuestro servidor o en tu dispositivo.
          </p>
          <h2 style={styles.subsectionTitle}>¿Qué es una baliza web?</h2>
          <p style={styles.legalText}>
            Una baliza web (o una etiqueta de píxel) es una pequeña e invisible
            pieza de texto o imagen en una web que se utiliza para monitorear el
            tráfico en una web. Para ello, se almacenan varios datos sobre usted
            mediante estas balizas web.
          </p>
          <h2 style={styles.subsectionTitle}>Cookies</h2>
          <h3 style={styles.subsectionTitle}>
            5.1 Cookies técnicas o funcionales
          </h3>
          <p style={styles.legalText}>
            Algunas cookies aseguran que ciertas partes de la web funcionen
            correctamente y que tus preferencias de usuario sigan recordándose.
            Al colocar cookies funcionales, te facilitamos la visita a nuestra
            web. De esta manera, no necesitas introducir repetidamente la misma
            información cuando visitas nuestra web y, por ejemplo, los artículos
            permanecen en tu cesta de la compra hasta que hayas pagado. Podemos
            colocar estas cookies sin tu consentimiento.
          </p>
          <h3 style={styles.subsectionTitle}>5.2 Cookies de estadísticas</h3>
          <p style={styles.legalText}>
            Utilizamos cookies estadísticas para optimizar la experiencia de la
            web para nuestros usuarios. Con estas cookies estadísticas obtenemos
            información sobre el uso de nuestra web. Te pedimos tu permiso para
            colocar cookies de estadísticas.
          </p>
          <h3 style={styles.subsectionTitle}>
            5.3 Cookies de marketing/seguimiento
          </h3>
          <p style={styles.legalText}>
            Las cookies de marketing/seguimiento son cookies, o cualquier otra
            forma de almacenamiento local, usadas para crear perfiles de usuario
            para mostrar publicidad o para hacer el seguimiento del usuario en
            esta web o en varias webs con fines de marketing similares.
          </p>
          <h2 style={styles.subsectionTitle}>Cookies usadas</h2>
          <p style={styles.legalText}>
            <strong>Google Analytics</strong>
            <br />
            <strong>Estadísticas</strong>
            <br />
            Consent to service: google-analytics
            <br />
            Uso: Usamos Google Analytics para estadísticas del sitio web. Leer
            más
            <br />
            Compartir datos: Para más información, por favor, lee la política de
            privacidad de Google Analytics.
            <br />
            <strong>Estadísticas</strong>
            <br />
            Nombre: ga
            <br />
            Caducidad: 2 años
            <br />
            Función: Contar y rastrear páginas vistas
          </p>
          <h2 style={styles.subsectionTitle}>Consentimiento</h2>
          <p style={styles.legalText}>
            Cuando visites nuestra web por primera vez, te mostraremos una
            ventana emergente con una explicación sobre las cookies. Tan pronto
            como hagas clic en «Guardar preferencias», aceptas que usemos las
            categorías de cookies y plugins que has seleccionado en la ventana
            emergente, tal y como se describe en esta política de cookies.
            Puedes desactivar el uso de cookies a través de tu navegador, pero,
            por favor, ten en cuenta que nuestra web puede dejar de funcionar
            correctamente.
          </p>
          <h2 style={styles.subsectionTitle}>
            7.1 Gestiona tus ajustes de consentimiento
          </h2>
          <p style={styles.legalText}>
            Has cargado la política de cookies sin compatibilidad con
            JavaScript. En AMP, puedes utilizar el botón de gestionar el
            consentimiento en la parte inferior de la página.
          </p>
          <h2 style={styles.subsectionTitle}>
            Activación/desactivación y borrado de cookies
          </h2>
          <p style={styles.legalText}>
            Puedes utilizar tu navegador de Internet para eliminar las cookies
            de forma automática o manual. También puedes especificar que ciertas
            cookies no pueden ser colocadas. Otra opción es cambiar los ajustes
            de tu navegador de Internet para que recibas un mensaje cada vez que
            se coloca una cookie. Para obtener más información sobre estas
            opciones, consulta las instrucciones de la sección «Ayuda» de tu
            navegador.
          </p>
          <p style={styles.legalText}>
            Ten en cuenta que nuestra web puede no funcionar correctamente si
            todas las cookies están desactivadas. Si borras las cookies de tu
            navegador, se volverán a colocar después de tu consentimiento cuando
            vuelvas a visitar nuestras webs.
          </p>
          <h2 style={styles.subsectionTitle}>
            Tus derechos con respecto a los datos personales
          </h2>
          <p style={styles.legalText}>
            Tienes los siguientes derechos con respecto a tus datos personales:
            <br />
            Derecho a saber por qué se necesitan tus datos personales, qué
            sucederá con ellos y durante cuánto tiempo se conservarán.
            <br />
            Derecho de acceso: tienes derecho a acceder a tus datos personales
            que conocemos.
            <br />
            Derecho de rectificación: tienes derecho a completar, rectificar,
            borrar o bloquear tus datos personales cuando lo desees.
            <br />
            Si nos das tu consentimiento para procesar tus datos, tienes derecho
            a revocar dicho consentimiento y a que se eliminen tus datos
            personales.
            <br />
            Derecho de cesión de tus datos: tienes derecho a solicitar todos tus
            datos personales al responsable del tratamiento y a transferirlos
            íntegramente a otro responsable del tratamiento.
            <br />
            Derecho de oposición: puedes oponerte al tratamiento de tus datos.
            Nosotros cumplimos con esto, a menos que existan motivos
            justificados para el procesamiento.
          </p>
          <h2 style={styles.subsectionTitle}>Datos de contacto</h2>
          <p style={styles.legalText}>
            Para preguntas y/o comentarios sobre nuestra política de cookies y
            esta declaración, por favor, contacta con nosotros usando los
            siguientes datos de contacto:
            <br />
            Bether Talent, SL
            <br />
            Marques de sentmenat 26 – 08014 Barcelona
            <br />
            España
            <br />
            Web: www.bether.ai
            <br />
            Correo electrónico: legal@bether.ai
          </p>
          <p style={styles.legalText}>
            Esta política de cookies se ha actualizado el 09 de Abril de 2025.
          </p>
        </>
      ),
    },
    ai: {
      headerTitle: 'Uso de IA',
      headerSubtitle: 'Información sobre el uso de inteligencia artificial.',
      content: (
        <>
          <p style={styles.legalText}>[Contenido sobre Uso de IA...]</p>
        </>
      ),
    },
  },
  en: {
    privacy: {
      headerTitle: 'Privacy Policy',
      headerSubtitle: '',
      content: (
        <>
          <h2 style={styles.subsectionTitle}>1. Introduction</h2>
          <p style={styles.legalText}>
            At Bether we work to provide the best possible experience to our
            users through our products and services. To achieve this, we collect
            personal information when necessary.
            <br />
            In compliance with the REGULATION (EU) 2016/679 OF THE EUROPEAN
            PARLIAMENT AND OF THE COUNCIL of 27 April 2016 ("GDPR"), and Law
            34/2002, of 11 July, on Information Society Services and Electronic
            Commerce ("LSSI"), Bether informs that it will process the personal
            data provided by users in a responsible and secure manner.
          </p>
          <h2 style={styles.subsectionTitle}>2. Data controller</h2>
          <p style={styles.legalText}>
            Bether Talent, SL (hereinafter, “Bether” or the “Company”) is the
            data controller for the personal data of the users. Its general
            details are:
            <br />
            <strong>Identity:</strong> Bether Talent, SL
            <br />
            <strong>Address:</strong> Marques de sentmenat 26 08014 BCN
            <br />
            <strong>Tax ID:</strong> B21864202
            <br />
            <strong>Email:</strong> legal@bether.ai
          </p>
          <p style={styles.legalText}>
            Bether has a Data Protection Officer. If you have any questions
            about the processing of your data, you can write to us at the email
            address indicated.
          </p>
          <h2 style={styles.subsectionTitle}>
            3. Collection and processing of personal data
          </h2>
          <p style={styles.legalText}>
            We may collect and process the following personal data:
            <br />
            <strong>Contact Form:</strong> Name, surname, email, phone number,
            and an optional message.
            <br />
            <strong>Platform Registration:</strong> Name, surname, email, phone
            number, and password. Registration can be done via third parties
            such as Google or Facebook.
            <br />
            <strong>Commercial Communications:</strong> Email and other data
            necessary to manage the service.
            <br />
            <strong>Customer Support:</strong> Email and any information shared
            in the support chat.
            <br />
            <strong>Job Application Form:</strong> Name, surname, email, phone
            number, CV, and optionally, a photograph. Applications can be
            submitted via LinkedIn or Indeed.
          </p>
          <h2 style={styles.subsectionTitle}>4. Legal basis for processing</h2>
          <p style={styles.legalText}>
            The processing of data is justified by:
            <br />- <strong>User Consent:</strong> For contact forms, newsletter
            subscriptions, job applications, and customer support.
            <br />- <strong>Compliance with Legal Obligations:</strong> For
            fraud prevention and communication with public authorities.
            <br />- <strong>Performance of a Contract:</strong> When processing
            is necessary for the provision of our services.
          </p>
          <h2 style={styles.subsectionTitle}>5. Data retention</h2>
          <p style={styles.legalText}>
            Personal data will be retained only for as long as necessary to
            fulfill the purposes for which it was collected or to comply with
            legal obligations. This means that the retention period may vary
            depending on the nature of the data and the reason for its
            processing.
            <br />
            To determine how long we retain personal data, we use the following
            criteria:
            <br />- <strong>Data provided in inquiries or requests:</strong> It
            will be retained as long as necessary to respond and manage the
            inquiry.
            <br />-{' '}
            <strong>
              Data collected with consent for commercial communications:
            </strong>{' '}
            It will be retained until the user withdraws their consent or until
            the end of the period for which it was required.
            <br />-{' '}
            <strong>
              Data processed for the performance of a contract:
            </strong>{' '}
            It will be retained during the contractual relationship and
            thereafter for the time necessary to comply with legal obligations.
            <br />-{' '}
            <strong>Data related to legal or regulatory obligations:</strong> It
            will be retained for the period required by applicable legislation.
            <br />
            In some cases, we may retain personal data for longer periods if
            necessary to comply with legal obligations, resolve disputes, or
            enforce our legal rights (for example, to file lawsuits).
            <br />
            Once the established retention periods have elapsed, we will proceed
            to delete the personal data from our systems and records securely
            or, where appropriate, anonymize it so that the user can no longer
            be identified.
            <br />
            Bether has a Data Retention Policy that specifies the retention
            periods in detail. For more information, please contact
            legal@bether.ai.
          </p>
          <h2 style={styles.subsectionTitle}>6. Data sharing</h2>
          <p style={styles.legalText}>
            In some cases, and only when necessary, Bether may share your data
            with third parties. However, under no circumstances will this data
            be sold to third parties.
            <br />
            External service providers on whom Bether relies for the provision
            of auxiliary services related to the processing of your data may
            have access to it, always under Bether’s instructions and solely for
            the purpose of fulfilling the contractual relationship established
            between Bether and these providers.
            <br />
            If you wish to obtain information about the providers that may have
            access to your personal data, please contact us at legal@bether.ai.
            <br />
            Bether is committed to ensuring the security of personal data when
            shared outside the company and to ensuring that external providers
            respect confidentiality and adopt adequate measures to protect it.
            <br />
            These third parties are obliged to process the information in
            accordance with current data privacy regulations. To ensure these
            protection measures, Bether enters into data processing agreements
            with these providers in compliance with Article 28 of the General
            Data Protection Regulation (GDPR).
            <br />
            In certain cases, applicable legislation may require the disclosure
            of personal data to public administrations or other entities. In
            such situations, Bether will only provide the information strictly
            necessary to comply with those legal obligations.
          </p>
          <h2 style={styles.subsectionTitle}>7. Data storage and transfer</h2>
          <p style={styles.legalText}>
            In general, data is stored within the European Union (EU). However,
            if the processing of your data involves an international transfer
            outside the European Economic Area (EEA), Bether undertakes to
            implement the necessary security measures to guarantee an adequate
            level of protection in such transfers.
            <br />
            To do so, Bether enters into data processing contracts with the
            involved providers and, where applicable, ensures that they offer an
            adequate level of protection, either through Binding Corporate Rules
            (BCR) or by adhering to the standard contractual clauses of the
            European Commission.
            <br />
            If you wish to obtain more information about our service providers,
            please contact us at legal@bether.ai.
          </p>
          <h2 style={styles.subsectionTitle}>8. User rights</h2>
          <p style={styles.legalText}>
            The user may exercise the following rights:
            <br />- Access their personal data.
            <br />- Rectify incorrect or outdated information.
            <br />- Request the deletion of their data.
            <br />- Restrict the processing of their information.
            <br />- Receive their data in a structured and readable format.
            <br />- Object to certain processing of their data.
            <br />
            To exercise these rights, please send a request to legal@bether.ai.
            If you believe that we have not managed your data properly, you may
            file a complaint with the Spanish Data Protection Agency.
          </p>
          <h2 style={styles.subsectionTitle}>
            9. Accuracy and veracity of the provided data
          </h2>
          <p style={styles.legalText}>
            The user is solely responsible for the accuracy and correctness of
            the data provided, thereby exonerating Bether from any liability in
            this regard. Users guarantee and are responsible at all times for
            the accuracy, validity, and authenticity of the provided
            information, undertaking to keep it updated.
            <br />
            The user undertakes to provide complete and truthful information in
            registration or subscription forms. Bether reserves the right to
            cancel contracted services if it is detected that the provided data
            is false, inaccurate, incomplete, or outdated.
            <br />
            Bether is not responsible for the accuracy of information coming
            from external sources and does not directly produce it; therefore,
            it assumes no liability for any damages or losses that may result
            from the use of such information.
            <br />
            Bether reserves the right to update, modify, or delete information
            contained on its website, and may even restrict or deny access to
            it.
          </p>
          <h2 style={styles.subsectionTitle}>
            10. Security measures to protect your personal data
          </h2>
          <p style={styles.legalText}>
            Bether has adopted the necessary security measures to protect
            personal data in accordance with current regulations. In addition,
            it implements other technical and organizational measures to prevent
            loss, misuse, alteration, unauthorized access, or theft of the
            personal data provided.
            <br />
            Bether is not responsible for any damages resulting from
            interferences, omissions, interruptions, computer viruses, system
            failures, or any other inconvenience beyond its control. Likewise,
            it cannot guarantee absolute security of information on the
            Internet, although it applies advanced measures to protect it.
            <br />
            The Bether website has a TLS certificate with RSA encryption,
            ensuring that all information sent through the site is protected via
            the HTTPS protocol.
          </p>
          <h2 style={styles.subsectionTitle}>
            11. Changes to the privacy policy
          </h2>
          <p style={styles.legalText}>
            This policy may be updated at any time. We recommend that you review
            it periodically.
          </p>
          <p style={styles.updateDate}>Last updated: 09/04/2025</p>
        </>
      ),
    },
    terms: {
      headerTitle: 'Terms & Conditions',
      headerSubtitle: 'Terms of Use',
      content: (
        <>
          <p style={styles.legalText}>
            Bether Talent, S.L. (Hereinafter Bether) is an online service that
            helps manage different aspects of a business. These terms outline
            the rights and responsibilities of users and Bether as the service
            provider.
            <br />
            By using the service, users accept these terms. Bether reserves the
            right to update or change the Terms of Use at any time without prior
            notice. The latest version will always be available at
            www.bether.ai.
            <br />
            Bether, with Tax Identification Number B21864202, is located at
            Marques de Sentmenat 26, 08014 Barcelona, and registered in the
            Mercantile Register of Barcelona, Tomo XXX, Folio XX, Page XXXX,
            inscription Xª. Bether provides its website and related services
            according to the terms stated below.
            <br />
            This agreement takes effect when you accept it by checking the box
            at the bottom of this document. Any new features added to the
            service will also be subject to these terms. Continued use of the
            service after modifications implies agreement to those changes. You
            can check the latest version at https://www.bether.ai/legal.
            <br />
            Failure to comply with these terms may result in account
            cancellation.
          </p>

          <h2 style={styles.subsectionTitle}>1. Account terms</h2>
          <p style={styles.legalText}>
            You must be at least 16 years old to use the service.
            <br />
            You must provide a full legal name, email address, and any other
            required information when creating an account.
            <br />
            You are responsible for providing truthful information. Bether
            reserves the right to delete accounts suspected of providing false
            information or violating usage rules.
            <br />
            You are responsible for maintaining account security. Bether is not
            liable for any loss or damage caused by a user failing to protect
            their login details.
            <br />
            Electronic acceptance of this agreement is legally binding. Bether
            may request written confirmation if necessary.
          </p>

          <h2 style={styles.subsectionTitle}>2. Agreements</h2>
          <p style={styles.legalText}>
            Bether offers different pricing plans based on document volume.
            Limits are specified at www.bether.ai/#pricing.
            <br />
            If you exceed the limits of your plan, you must upgrade.
            <br />
            Bether reserves the right to change pricing at any time without
            compensation to users.
          </p>

          <h2 style={styles.subsectionTitle}>3. Payment and access</h2>
          <p style={styles.legalText}>
            A valid bank card is required for payments, except for free
            accounts.
            <br />
            Bether charges fees in advance, and payments are non-refundable.
            <br />
            No refunds or credits are provided for unused service time or
            partial months.
            <br />
            Users agree that electronic confirmation is sufficient for contract
            acceptance.
            <br />
            If an account upgrade is required due to document volume, the new
            charge will take effect at the next billing cycle.
            <br />
            In case of non-payment, access will be revoked, and data will be
            deleted after 30 days.
            <br />
            Fees do not include taxes; users are responsible for paying
            applicable taxes.
            <br />
            Users control who can access their accounts and assign roles
            accordingly.
          </p>

          <h2 style={styles.subsectionTitle}>
            4. Service and pricing modifications
          </h2>
          <p style={styles.legalText}>
            Bether may modify or suspend the service at any time, with or
            without notice.
            <br />
            Pricing changes will be announced on the website and in writing at
            least 15 days in advance.
          </p>

          <h2 style={styles.subsectionTitle}>5. Cancellation</h2>
          <p style={styles.legalText}>
            Users can cancel their account anytime through the profile menu.
            <br />
            Once canceled, all content will be deleted after 30 days.
            <br />
            Users are responsible for any charges incurred up to cancellation,
            including full monthly fees.
            <br />
            Bether reserves the right to cancel accounts that violate these
            terms.
          </p>

          <h2 style={styles.subsectionTitle}>
            6. Copyright and intellectual property
          </h2>
          <p style={styles.legalText}>
            Bether owns all intellectual property rights to the service,
            including software, design, and branding.
            <br />
            Users cannot copy, adapt, distribute, or reverse-engineer the
            service.
            <br />
            Automated tools (e.g., bots, spiders) cannot be used to monitor or
            copy content.
            <br />
            Users retain ownership of their content but acknowledge that third
            parties may view or share it through the service.
          </p>

          <h2 style={styles.subsectionTitle}>7. General terms</h2>
          <p style={styles.legalText}>
            Users must comply with applicable laws and act in good faith when
            using Bether.
            <br />
            Users may not resell, duplicate, or exploit any part of the service
            without written consent from Bether.
            <br />
            The service cannot be used to send spam or store harmful content.
            <br />
            Bether does not guarantee uninterrupted service or error-free
            operation.
            <br />
            Bether is not responsible for any direct or indirect damages arising
            from service use.
            <br />
            If any part of these terms is deemed invalid, the remaining terms
            will still apply.
            <br />
            Questions about these terms should be directed to Bether Technical
            Support: support@bether.ai.
            <br />
            These terms override any previous agreements and are governed by
            Spanish law.
            <br />
            Any disputes will be handled in the courts of Barcelona.
          </p>

          <h2 style={styles.subsectionTitle}>8. Security and privacy</h2>
          <p style={styles.legalText}>
            Bether complies with Spanish data protection regulations and is
            registered with the Spanish Data Protection Agency.
            <br />
            User data is stored on Amazon servers in the EU, ensuring compliance
            with data hosting regulations and high security standards.
          </p>

          <h2 style={styles.subsectionTitle}>Refund policy</h2>
          <p style={styles.legalText}>
            <strong>Monthly Subscriptions:</strong> If dissatisfied within your
            first month, contact us. We will attempt to resolve the issue. If
            unsatisfied, you will receive a full refund, and your account will
            be downgraded to the free plan.
            <br />
            <strong>Annual Subscriptions:</strong> Annual plans offer a
            discount. If dissatisfied within the first 30 days, contact us. If
            we cannot resolve your issue, we will provide a full refund and
            downgrade your account.
            <br />
            <strong>Auto-Renewal:</strong> Subscriptions renew automatically. If
            you forget to cancel before renewal, you can still cancel within 7
            business days and receive a full refund.
            <br />
            <strong>Refund Exceptions:</strong> Refunds will not be granted if
            your account was suspended or terminated due to a breach of these
            terms.
          </p>
        </>
      ),
    },
    cookies: {
      headerTitle: 'Cookies Policy',
      headerSubtitle: 'Our use of cookies on our platform.',
      content: (
        <>
          <h2 style={styles.subsectionTitle}>Cookies Policy</h2>
          <p style={styles.legalText}>
            This cookies policy has been updated and applies to citizens and
            legal permanent residents of the European Economic Area and
            Switzerland.
          </p>
          <h2 style={styles.subsectionTitle}>Introduction</h2>
          <p style={styles.legalText}>
            Our website, www.bether.ai (hereinafter referred to as “the
            website”), uses cookies and other related technologies (for
            convenience, all such technologies are called “cookies”). Cookies
            are also set by third parties that we have contracted. In this
            document, we inform you about the use of cookies on our website.
          </p>
          <h2 style={styles.subsectionTitle}>What are cookies?</h2>
          <p style={styles.legalText}>
            A cookie is a small file that is sent along with the pages of this
            website and stored by your browser on your computer’s hard drive or
            another device. The stored information may be returned to our
            servers or to the appropriate third-party servers during a
            subsequent visit.
          </p>
          <h2 style={styles.subsectionTitle}>What are scripts?</h2>
          <p style={styles.legalText}>
            A script is a piece of programming code used to make our website
            function properly and interactively. This code is executed either on
            our server or on your device.
          </p>
          <h2 style={styles.subsectionTitle}>What is a web beacon?</h2>
          <p style={styles.legalText}>
            A web beacon (or pixel tag) is a small and invisible piece of text
            or image on a website used to monitor website traffic. Various data
            about you may be collected using these web beacons.
          </p>
          <h2 style={styles.subsectionTitle}>Cookies</h2>
          <h3 style={styles.subsectionTitle}>
            5.1 Technical or Functional Cookies
          </h3>
          <p style={styles.legalText}>
            Some cookies ensure that certain parts of the website work correctly
            and that your user preferences are remembered. By placing functional
            cookies, we facilitate your visit to our website. This way, you do
            not have to repeatedly enter the same information when visiting our
            website, and for example, items remain in your shopping cart until
            you have paid. We may set these cookies without your consent.
          </p>
          <h3 style={styles.subsectionTitle}>5.2 Statistical Cookies</h3>
          <p style={styles.legalText}>
            We use statistical cookies to optimize the website experience for
            our users. These cookies collect information about how our website
            is used. We ask for your permission to set statistical cookies.
          </p>
          <h3 style={styles.subsectionTitle}>5.3 Marketing/Tracking Cookies</h3>
          <p style={styles.legalText}>
            Marketing/tracking cookies are cookies, or any other form of local
            storage, used to create user profiles for displaying advertisements
            or for tracking the user on this website or across multiple websites
            for similar marketing purposes.
          </p>
          <h2 style={styles.subsectionTitle}>Cookies Used</h2>
          <p style={styles.legalText}>
            <strong>Google Analytics</strong>
            <br />
            <strong>Statistics</strong>
            <br />
            Consent to service: google-analytics
            <br />
            Usage: We use Google Analytics for website statistics. Read more
            <br />
            Data sharing: For more information, please read the Google Analytics
            privacy policy.
            <br />
            <strong>Statistics</strong>
            <br />
            Name: ga
            <br />
            Expiration: 2 years
            <br />
            Function: Count and track page views
          </p>
          <h2 style={styles.subsectionTitle}>Consent</h2>
          <p style={styles.legalText}>
            When you visit our website for the first time, we will display a
            pop-up window with an explanation about cookies. As soon as you
            click “Save preferences”, you agree to our use of the cookie and
            plugin categories you have selected in the pop-up, as described in
            this cookies policy. You can disable the use of cookies via your
            browser, but please note that our website may not function
            correctly.
          </p>
          <h2 style={styles.subsectionTitle}>
            7.1 Manage Your Consent Settings
          </h2>
          <p style={styles.legalText}>
            You have loaded the cookies policy without JavaScript support. In
            AMP, you can use the “manage consent” button at the bottom of the
            page.
          </p>
          <h2 style={styles.subsectionTitle}>
            Enabling/Disabling and Deleting Cookies
          </h2>
          <p style={styles.legalText}>
            You can use your web browser to delete cookies automatically or
            manually. You can also specify that certain cookies should not be
            set. Alternatively, you can change your browser settings to receive
            a notification each time a cookie is set. For more information about
            these options, please refer to the “Help” section of your browser.
          </p>
          <p style={styles.legalText}>
            Please note that our website may not function correctly if all
            cookies are disabled. If you delete cookies from your browser, they
            will be re-set after your consent when you revisit our websites.
          </p>
          <h2 style={styles.subsectionTitle}>
            Your Rights Regarding Personal Data
          </h2>
          <p style={styles.legalText}>
            You have the following rights regarding your personal data:
            <br />
            Right to know: You have the right to know why your personal data is
            needed, what will happen to it, and for how long it will be
            retained.
            <br />
            Right of access: You have the right to access the personal data we
            hold about you.
            <br />
            Right to rectification: You have the right to complete, rectify,
            delete, or block your personal data whenever you wish.
            <br />
            If you give us your consent to process your data, you have the right
            to withdraw that consent and have your personal data deleted.
            <br />
            Right to data portability: You have the right to request all your
            personal data from the data controller and to transfer it in full to
            another data controller.
            <br />
            Right to object: You may object to the processing of your data. We
            comply with this unless there are justified grounds for the
            processing.
          </p>
          <h2 style={styles.subsectionTitle}>Contact Information</h2>
          <p style={styles.legalText}>
            For any questions and/or comments about our cookies policy and this
            statement, please contact us using the following details:
            <br />
            Bether Talent, SL
            <br />
            Marques de sentmenat 26 08014 Barcelona
            <br />
            Spain
            <br />
            Website: www.bether.ai
            <br />
            Email: legal@bether.ai
          </p>
          <p style={styles.legalText}>
            This cookies policy was updated on April 9, 2025.
          </p>
        </>
      ),
    },
    ai: {
      headerTitle: 'AI Usage',
      headerSubtitle:
        'Information regarding the use of artificial intelligence.',
      content: (
        <>
          <p style={styles.legalText}>[AI Usage content...]</p>
        </>
      ),
    },
  },
};

function LegalPageTabs() {
  // Initialize language from localStorage or fallback to 'es'
  const [language, setLanguage] = useState(
    () => localStorage.getItem('language') || 'es'
  );
  // State for the active tab (privacy, terms, cookies, ai)
  const [activeTab, setActiveTab] = useState('privacy');

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  // Get the current tab translations
  const t = translations[language][activeTab];

  return (
    <div style={styles.container}>
      <NavBarHome language={language} />

      {/* Tabs Header placed immediately after the navbar */}
      <div style={styles.tabsHeader}>
        <div className="flex space-x-4">
          <button
            onClick={() => setActiveTab('privacy')}
            className={`px-4 py-2 text-sm ${
              activeTab === 'privacy'
                ? 'border-b-2 border-red-600 text-red-600 font-bold'
                : 'text-gray-600 hover:text-red-600 font-normal'
            }`}
          >
            <FontAwesomeIcon icon={faLock} className="mr-2" />
            {language === 'es' ? 'Privacidad' : 'Privacy'}
          </button>
          <button
            onClick={() => setActiveTab('terms')}
            className={`px-4 py-2 text-sm ${
              activeTab === 'terms'
                ? 'border-b-2 border-red-600 text-red-600 font-bold'
                : 'text-gray-600 hover:text-red-600 font-normal'
            }`}
          >
            <FontAwesomeIcon icon={faFileContract} className="mr-2" />
            {language === 'es'
              ? 'Términos y condiciones'
              : 'Terms & Conditions'}
          </button>
          <button
            onClick={() => setActiveTab('cookies')}
            className={`px-4 py-2 text-sm ${
              activeTab === 'cookies'
                ? 'border-b-2 border-red-600 text-red-600 font-bold'
                : 'text-gray-600 hover:text-red-600 font-normal'
            }`}
          >
            <FontAwesomeIcon icon={faSpaghettiMonsterFlying} className="mr-1" />
            <FontAwesomeIcon icon={faCookieBite} className="mr-2" />
            Cookies
          </button>
          <button
            onClick={() => setActiveTab('ai')}
            className={`px-4 py-2 text-sm ${
              activeTab === 'ai'
                ? 'border-b-2 border-red-600 text-red-600 font-bold'
                : 'text-gray-600 hover:text-red-600 font-normal'
            }`}
          >
            <FontAwesomeIcon icon={faWandSparkles} className="mr-2" />
            {language === 'es' ? 'Uso de IA' : 'AI Usage'}
          </button>
        </div>
      </div>

      {/* Main Content Section */}
      <main style={styles.mainSection}>
        <h1 style={styles.title}>{t.headerTitle}</h1>
        {t.headerSubtitle && (
          <p style={styles.headerSubtitle}>{t.headerSubtitle}</p>
        )}
        {t.content}
      </main>

      {/* Footer (Language selector remains here) */}
      <FooterHome language={language} setLanguage={setLanguage} />
    </div>
  );
}

export default LegalPageTabs;
